import { Component, Input, Inject } from '@angular/core';
import { Router } from '@angular/router';

import { Hotel, Reservation, ReservationStayPreferences, MessageType, ReservationErrorMessageKeys } from '../../api/model';
import { IAppConfig } from '../../store';
import { APP_CONFIG } from '../../api/config';
import { IMessage } from '../../api/interfaces/Messages/IMessage';
import { ApplicationRouteNames } from '../../common/model';

@Component({
  selector: 'room-stay-preferences',
  templateUrl: './room-stay-preferences.component.html',
  styleUrls: ['./room-stay-preferences.component.scss']
})

export class RoomStayPreferencesComponent {
  private _stayPreferences: ReservationStayPreferences;
  private _updated: boolean;
  @Input() messages;
  @Input() isOpen: boolean;
  @Input() hotel: Hotel;
  @Input() reservation: Reservation;
  message: IMessage = null;
  hasExistingPreferences: boolean;

  constructor(@Inject(APP_CONFIG) protected appConfig: IAppConfig, private _router: Router) {
  }

  @Input()
  set updated(value: boolean) {
    this._updated = value;
    this.message = this.updated ? <IMessage>{ key: ReservationErrorMessageKeys.SUCCESS_LOCAL_STAY_PREFERENCES, messageType: MessageType.SUCCESS } : null;
  }
  @Input()
  set stayPreferences(value: ReservationStayPreferences) {
    this._stayPreferences = value;
    this.hasExistingPreferences = !!value && value.userPreferenceSelected;
  }
  get updated(): boolean {
    return this._updated;
  }
  get stayPreferences(): ReservationStayPreferences {
    return this._stayPreferences;
  }

  redirectToStayPreferences() {
    this._router.navigate([ApplicationRouteNames.STAY_PREFERENCES, this.reservation.confirmationNumber, this.reservation.guest.lastName]);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/room-stay-preferences/room-stay-preferences.component.ts